/* IT HIPPIE — Pont tactile pour le quick-add du carrousel panier (mobile).

   Contexte : le "+" du carrousel est injecté par ith-quick-add (snippet ith-quick-add.liquid),
   et son clic ouvre le popup quick add (openQA). Sur desktop ça marche.
   Sur mobile (iOS surtout), quand le tiroir panier est ouvert, le verrou de scroll
   du tiroir supprime le "clic" synthétique généré par le tap -> le bouton ne réagit pas.

   Correctif : on écoute le touchend sur le "+" du carrousel et on déclenche le bouton
   par programme (btn.click()), ce qui appelle bien openQA. Desktop : pas de touchend,
   le clic natif d'ith-quick-add fonctionne déjà -> ce code reste dormant.

   Portée : limité à .cpb-upsell__card .ith-qa-btn (le carrousel du panier),
   donc aucun impact sur le quick add des pages collection. */
(function() {
  if (window.__cpbUpsellTapBridge) return;
  window.__cpbUpsellTapBridge = true;

  document.addEventListener('touchend', function(e) {
    var btn = e.target.closest('.cpb-upsell__card .ith-qa-btn');
    if (!btn) return;
    // Empêche le clic synthétique (qui serait supprimé) + la navigation du lien sous le bouton
    e.preventDefault();
    e.stopPropagation();
    // Déclenche le handler d'ith-quick-add (ouvre openQA / la cloche "M'avertir")
    btn.click();
  }, { passive: false });
})();
